export default __webpack_public_path__ + "static/media/03.6b0cef1e.png";